// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1d2yi","modal":"Modal_modal__3bSDH","customStyle":"Modal_customStyle__15kp4"};